import {Palette} from 'hubbl-shared';
import {memo} from 'react';
import styled, {keyframes} from 'styled-components';

interface TextTickerProps {
  label?: string;
  duration?: number;
  height?: number;
  backgroundColor?: string;
}

const scrollAnimation = keyframes`
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
`;

export const TextTicker = memo(
  ({
    label,
    duration = 9000,
    height = 28,
    backgroundColor = Palette.primaryBianca,
  }: TextTickerProps) => {
    const text =
      label ??
      `You are invited ✉️ 🥳   You are invited ✉️ 🥳   You are invited ✉️ 🥳   `;

    return (
      <TickerContainer height={height} backgroundColor={backgroundColor}>
        <TickerText duration={duration}>{text}</TickerText>
      </TickerContainer>
    );
  },
);

const TickerContainer = styled.div<{
  height: number;
  backgroundColor: string;
}>`
  height: ${props => props.height}px;
  background-color: ${props => props.backgroundColor};
  overflow: hidden;
  display: flex;
  align-items: center;
  pointer-events: none;
  position: relative;
  width: 100%;
  bottom: 8px;
`;

const TickerText = styled.div<{duration: number}>`
  color: ${Palette.almostBlack};
  font-size: 0.75rem;
  font-weight: 500;
  white-space: nowrap;
  animation: ${scrollAnimation} ${props => props.duration}ms linear infinite;
  display: inline-block;
  min-width: 100%;
`;
